import React from "react";
import { CharacterSheet } from "../data/characterSchema";

interface Props {
  character: CharacterSheet;
  onChange: (character: CharacterSheet) => void;
}

export const InformacoesBasicas: React.FC<Props> = ({ character, onChange }) => {
  const updateField = (field: keyof CharacterSheet, value: any) => {
    onChange({ ...character, [field]: value });
  };

  return (
    <div className="section">
      <h2>Informações Básicas</h2>
      <div className="form-grid">
        <div className="form-group">
          <label>Nome do Personagem</label>
          <input
            type="text"
            value={character.nomePersonagem}
            onChange={(e) => updateField("nomePersonagem", e.target.value)}
            placeholder="Nome do personagem"
          />
        </div>
        <div className="form-group">
          <label>Jogador</label>
          <input
            type="text"
            value={character.jogador}
            onChange={(e) => updateField("jogador", e.target.value)}
            placeholder="Nome do jogador"
          />
        </div>
        <div className="form-group">
          <label>Data de Criação</label>
          <input
            type="text"
            value={character.dataCriacao}
            onChange={(e) => updateField("dataCriacao", e.target.value)}
            placeholder="DD/MM/AAAA"
          />
        </div>
        <div className="form-group">
          <label>Nível de Experiência</label>
          <input
            type="number"
            value={character.nivelExperiencia}
            onChange={(e) => updateField("nivelExperiencia", parseInt(e.target.value) || 0)}
            min="0"
          />
        </div>
        <div className="form-group">
          <label>Reino Atual</label>
          <input
            type="text"
            value={character.reinoAtual}
            onChange={(e) => updateField("reinoAtual", e.target.value)}
            placeholder="Ex: Qi Condensado"
          />
        </div>
      </div>
    </div>
  );
};
